<template>
  <TabLayout class="marketing" :tabs="tabs">
    <template v-slot:title>
      <h1 class="mb-0">{{$t('Marketing')}}</h1>
    </template>
  </TabLayout>
</template>

<script>
  import TabLayout from "@/core/components/layout/DefaultLayout/TabLayout";
  import i18n from "@/shared/i18n";

  export default {
    name: "CustomerView",
    components: {
      TabLayout
    },
    data() {
      return {
        tabs: [
          {title: i18n.t('Audiences'), icon: 'list', to: {name: 'marketing.audiences'}},
          {title: i18n.t('Customer Navigator'), icon: 'users', to: {name: 'marketing.customers'}},
        ]
      }
    }
  }
</script>

<style lang="scss">
  @import "./scss/variables";

  .customer-view {
    @include view-page-wrapper;
  }
</style>
